import React, { createContext, useContext } from 'react';

interface EcwTabContextProps {
    openEcwTab: (initialUrl?: string) => void;
    navigateEcwTab: (relativeUrl: string) => void;
    buildEncounterUrl: (encounterID: string | number) => string;
    buildEraCheckUrl: (checkNo: string, detailId?: string, paymentId?: string, invoiceId?: string) => string;
    useEcwLan: boolean;
    toggleEcwLan: () => void;
}

const EcwTabContext = createContext<EcwTabContextProps>({
    openEcwTab: () => {},
    navigateEcwTab: () => {},
    buildEncounterUrl: () => '',
    buildEraCheckUrl: () => '',
    useEcwLan: false,
    toggleEcwLan: () => {},
});

export const EcwTabProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    // Get EMR URL preference from localStorage
    const getEmrUrlPreference = () => {
        return localStorage.getItem('useEcwLan') === 'true';
    };

    const getBaseUrl = () => {
        const useLan = getEmrUrlPreference();
        return useLan 
            ? 'http://192.168.1.17:8080/mobiledoc'
            : 'https://emr.apexheartcare.com/mobiledoc';
    };

    const getLoginUrl = () => {
        const useLan = getEmrUrlPreference();
        return useLan 
            ? 'http://192.168.1.17:8080/mobiledoc/jsp/webemr/login/newLogin.jsp'
            : 'https://emr.apexheartcare.com/mobiledoc/jsp/webemr/login/newLogin.jsp';
    };

    const toggleEcwLan = () => {
        const currentValue = getEmrUrlPreference();
        localStorage.setItem('useEcwLan', String(!currentValue));
        // Force re-render by updating context
        window.location.reload();
    };

    const openEcwTab = (initialUrl?: string) => {
        const url = initialUrl || getLoginUrl();
        window.open(url, '_ecwTab');
    };

    const navigateEcwTab = (relativeUrl: string) => {
        window.open(`${getBaseUrl()}/${relativeUrl}`, '_ecwTab');
    };

    const buildEncounterUrl = (encounterID: string | number) =>
        `${getBaseUrl()}/jsp/catalog/xml/printChartOption5.jsp?sessionDID=9121&FormData=Default&TrUserId=9121&isHtml=true&style=ModernI&encounterID=${encounterID}`;

    const buildEraCheckUrl = (
        checkNo: string,
        detailId: string = '0',
        paymentId: string = '0',
        invoiceId: string = ''
    ) => {
        let url = `${getBaseUrl()}/jsp/edi/x12utils/ViewEraFile_Encode.jsp?sessionDID=9121&TrUserId=9121&CheckNo=${checkNo}&DetailId=${detailId}&PaymentId=${paymentId}`;
        if (invoiceId) {
            url += `&InvoiceId=${invoiceId}`;
        }
        return url;
    };

    return (
        <EcwTabContext.Provider value={{ 
            openEcwTab, 
            navigateEcwTab, 
            buildEncounterUrl, 
            buildEraCheckUrl,
            useEcwLan: getEmrUrlPreference(),
            toggleEcwLan
        }}>
            {children}
        </EcwTabContext.Provider>
    );
};

export const useEcwTab = () => useContext(EcwTabContext);
